// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/queryconsts.proto (package aurora.core.consts.query, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Side } from "./commonconsts_pb";
import { file_consts_commonconsts } from "./commonconsts_pb";
import type { OmsOrderStatus, OmsOrderType, OmsTimeInForceType, OrderIntent, RoutingStatus } from "./omsconsts_pb";
import { file_consts_omsconsts } from "./omsconsts_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file consts/queryconsts.proto.
 */
export const file_consts_queryconsts: GenFile = /*@__PURE__*/
  fileDesc("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", [file_consts_commonconsts, file_consts_omsconsts]);

/**
 * @generated from message aurora.core.consts.query.BigintFilter
 */
export type BigintFilter = Message<"aurora.core.consts.query.BigintFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: int64 filter = 2;
   */
  filter: bigint;

  /**
   * @generated from field: optional int64 filter_to = 3;
   */
  filterTo?: bigint;
};

/**
 * Describes the message aurora.core.consts.query.BigintFilter.
 * Use `create(BigintFilterSchema)` to create a new message.
 */
export const BigintFilterSchema: GenMessage<BigintFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 0);

/**
 * @generated from message aurora.core.consts.query.DecimalFilter
 */
export type DecimalFilter = Message<"aurora.core.consts.query.DecimalFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string filter = 2;
   */
  filter: string;

  /**
   * @generated from field: optional string filter_to = 3;
   */
  filterTo?: string;
};

/**
 * Describes the message aurora.core.consts.query.DecimalFilter.
 * Use `create(DecimalFilterSchema)` to create a new message.
 */
export const DecimalFilterSchema: GenMessage<DecimalFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 1);

/**
 * @generated from message aurora.core.consts.query.DateFilter
 */
export type DateFilter = Message<"aurora.core.consts.query.DateFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: optional string date_from = 2;
   */
  dateFrom?: string;

  /**
   * @generated from field: optional string date_to = 3;
   */
  dateTo?: string;
};

/**
 * Describes the message aurora.core.consts.query.DateFilter.
 * Use `create(DateFilterSchema)` to create a new message.
 */
export const DateFilterSchema: GenMessage<DateFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 2);

/**
 * @generated from message aurora.core.consts.query.StringFilter
 */
export type StringFilter = Message<"aurora.core.consts.query.StringFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string filter = 2;
   */
  filter: string;

  /**
   * @generated from field: optional string filter_to = 3;
   */
  filterTo?: string;
};

/**
 * Describes the message aurora.core.consts.query.StringFilter.
 * Use `create(StringFilterSchema)` to create a new message.
 */
export const StringFilterSchema: GenMessage<StringFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 3);

/**
 * @generated from message aurora.core.consts.query.StringSetFilter
 */
export type StringSetFilter = Message<"aurora.core.consts.query.StringSetFilter"> & {
  /**
   * @generated from field: repeated string values = 1;
   */
  values: string[];
};

/**
 * Describes the message aurora.core.consts.query.StringSetFilter.
 * Use `create(StringSetFilterSchema)` to create a new message.
 */
export const StringSetFilterSchema: GenMessage<StringSetFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 4);

/**
 * @generated from message aurora.core.consts.query.SideFilter
 */
export type SideFilter = Message<"aurora.core.consts.query.SideFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: aurora.core.consts.common.Side filter = 2;
   */
  filter: Side;
};

/**
 * Describes the message aurora.core.consts.query.SideFilter.
 * Use `create(SideFilterSchema)` to create a new message.
 */
export const SideFilterSchema: GenMessage<SideFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 5);

/**
 * @generated from message aurora.core.consts.query.OrderStatusSetFilter
 */
export type OrderStatusSetFilter = Message<"aurora.core.consts.query.OrderStatusSetFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: repeated aurora.core.consts.query.OrderStatusFilterField values = 2;
   */
  values: OrderStatusFilterField[];
};

/**
 * Describes the message aurora.core.consts.query.OrderStatusSetFilter.
 * Use `create(OrderStatusSetFilterSchema)` to create a new message.
 */
export const OrderStatusSetFilterSchema: GenMessage<OrderStatusSetFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 6);

/**
 * @generated from message aurora.core.consts.query.OrderStatusFilterField
 */
export type OrderStatusFilterField = Message<"aurora.core.consts.query.OrderStatusFilterField"> & {
  /**
   * @generated from field: aurora.core.consts.oms.OmsOrderStatus order_status = 2;
   */
  orderStatus: OmsOrderStatus;

  /**
   * @generated from field: optional bool has_executed = 3;
   */
  hasExecuted?: boolean;
};

/**
 * Describes the message aurora.core.consts.query.OrderStatusFilterField.
 * Use `create(OrderStatusFilterFieldSchema)` to create a new message.
 */
export const OrderStatusFilterFieldSchema: GenMessage<OrderStatusFilterField> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 7);

/**
 * @generated from message aurora.core.consts.query.OrderTypeFilter
 */
export type OrderTypeFilter = Message<"aurora.core.consts.query.OrderTypeFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: aurora.core.consts.oms.OmsOrderType filter = 2;
   */
  filter: OmsOrderType;
};

/**
 * Describes the message aurora.core.consts.query.OrderTypeFilter.
 * Use `create(OrderTypeFilterSchema)` to create a new message.
 */
export const OrderTypeFilterSchema: GenMessage<OrderTypeFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 8);

/**
 * @generated from message aurora.core.consts.query.OrderIntentFilter
 */
export type OrderIntentFilter = Message<"aurora.core.consts.query.OrderIntentFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: aurora.core.consts.oms.OrderIntent filter = 2;
   */
  filter: OrderIntent;
};

/**
 * Describes the message aurora.core.consts.query.OrderIntentFilter.
 * Use `create(OrderIntentFilterSchema)` to create a new message.
 */
export const OrderIntentFilterSchema: GenMessage<OrderIntentFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 9);

/**
 * @generated from message aurora.core.consts.query.RoutingStatusFilter
 */
export type RoutingStatusFilter = Message<"aurora.core.consts.query.RoutingStatusFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: aurora.core.consts.oms.RoutingStatus filter = 2;
   */
  filter: RoutingStatus;
};

/**
 * Describes the message aurora.core.consts.query.RoutingStatusFilter.
 * Use `create(RoutingStatusFilterSchema)` to create a new message.
 */
export const RoutingStatusFilterSchema: GenMessage<RoutingStatusFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 10);

/**
 * @generated from message aurora.core.consts.query.TimeInForceFilter
 */
export type TimeInForceFilter = Message<"aurora.core.consts.query.TimeInForceFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: aurora.core.consts.oms.OmsTimeInForceType filter = 2;
   */
  filter: OmsTimeInForceType;
};

/**
 * Describes the message aurora.core.consts.query.TimeInForceFilter.
 * Use `create(TimeInForceFilterSchema)` to create a new message.
 */
export const TimeInForceFilterSchema: GenMessage<TimeInForceFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 11);

/**
 * @generated from message aurora.core.consts.query.BooleanFilter
 */
export type BooleanFilter = Message<"aurora.core.consts.query.BooleanFilter"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: bool filter = 2;
   */
  filter: boolean;
};

/**
 * Describes the message aurora.core.consts.query.BooleanFilter.
 * Use `create(BooleanFilterSchema)` to create a new message.
 */
export const BooleanFilterSchema: GenMessage<BooleanFilter> = /*@__PURE__*/
  messageDesc(file_consts_queryconsts, 12);

/**
 * @generated from enum aurora.core.consts.query.SortableField
 */
export enum SortableField {
  /**
   * @generated from enum value: UNSPECIFIED_QUERY_ORDERS_SORTABLE_FIELD = 0;
   */
  UNSPECIFIED_QUERY_ORDERS_SORTABLE_FIELD = 0,

  /**
   * Status
   *
   * @generated from enum value: STATUS = 1;
   */
  STATUS = 1,

  /**
   * Created time
   *
   * @generated from enum value: CREATED_AT = 2;
   */
  CREATED_AT = 2,

  /**
   * Created by User
   *
   * @generated from enum value: CREATED_BY = 40;
   */
  CREATED_BY = 40,

  /**
   * Last Update time
   *
   * @generated from enum value: UPDATED_AT = 3;
   */
  UPDATED_AT = 3,

  /**
   * Last Update by User
   *
   * @generated from enum value: LAST_UPDATED_BY = 41;
   */
  LAST_UPDATED_BY = 41,

  /**
   * Side
   *
   * @generated from enum value: SIDE = 4;
   */
  SIDE = 4,

  /**
   * Staged
   *
   * @generated from enum value: ROUTING_STATUS = 5;
   */
  ROUTING_STATUS = 5,

  /**
   * Ticker
   *
   * @generated from enum value: INSTRUMENT_TICKER = 6;
   */
  INSTRUMENT_TICKER = 6,

  /**
   * Cusip
   *
   * @generated from enum value: INSTRUMENT_CUSIP = 7;
   */
  INSTRUMENT_CUSIP = 7,

  /**
   * Open Quantity
   *
   * @generated from enum value: OPEN_QUANTITY = 8;
   */
  OPEN_QUANTITY = 8,

  /**
   * Filled Quantity
   *
   * @generated from enum value: FILLED_QUANTITY = 9;
   */
  FILLED_QUANTITY = 9,

  /**
   * Total Quantity
   *
   * @generated from enum value: TOTAL_QUANTITY = 10;
   */
  TOTAL_QUANTITY = 10,

  /**
   * Fee
   *
   * @generated from enum value: FEE = 11;
   */
  FEE = 11,

  /**
   * Rebate
   *
   * @generated from enum value: REBATE = 18;
   */
  REBATE = 18,

  /**
   * Average Execution Fee
   *
   * @generated from enum value: AVG_EXEC_FEE = 12;
   */
  AVG_EXEC_FEE = 12,

  /**
   * Average Execution Rebate
   *
   * @generated from enum value: AVG_EXEC_REBATE = 19;
   */
  AVG_EXEC_REBATE = 19,

  /**
   * Order Type
   *
   * @generated from enum value: TYPE = 13;
   */
  TYPE = 13,

  /**
   * Time In Force
   *
   * @generated from enum value: TIME_IN_FORCE = 14;
   */
  TIME_IN_FORCE = 14,

  /**
   * Minimum Quantity
   *
   * @generated from enum value: MIN_QUANTITY = 15;
   */
  MIN_QUANTITY = 15,

  /**
   * Company Name of the owner
   *
   * @generated from enum value: COMPANY_NAME = 17;
   */
  COMPANY_NAME = 17,

  /**
   * Instrument Name
   *
   * @generated from enum value: SECURITY_NAME = 20;
   */
  SECURITY_NAME = 20,

  /**
   * Instrument Type
   *
   * @generated from enum value: SECURITY_TYPE = 26;
   */
  SECURITY_TYPE = 26,

  /**
   * Instrument Category
   *
   * @generated from enum value: SECURITY_CATEGORY = 43;
   */
  SECURITY_CATEGORY = 43,

  /**
   * Expiration time
   *
   * @generated from enum value: GOOD_TILL_TIME = 21;
   */
  GOOD_TILL_TIME = 21,

  /**
   * Agreements - Not implemented
   *
   * @generated from enum value: AGREEMENTS = 22;
   */
  AGREEMENTS = 22,

  /**
   * Last close price of the instrument
   *
   * @generated from enum value: UNIT_PRICE = 23;
   */
  UNIT_PRICE = 23,

  /**
   * Last close price of the instrument
   *
   * @generated from enum value: PRICE_CHANGE = 42;
   */
  PRICE_CHANGE = 42,

  /**
   * Market value of the order based on the last close of the instrument
   *
   * @generated from enum value: OPEN_MARKET_VALUE = 24;
   */
  OPEN_MARKET_VALUE = 24,

  /**
   * Client order ref
   *
   * @generated from enum value: ORDER_REF = 25;
   */
  ORDER_REF = 25,

  /**
   * Best Offer Quantity
   *
   * @generated from enum value: BO_QUANTITY = 27;
   */
  BO_QUANTITY = 27,

  /**
   * Best Offer Fee
   *
   * @generated from enum value: BO_FEE = 28;
   */
  BO_FEE = 28,

  /**
   * Best Offer Rebate
   *
   * @generated from enum value: BO_REBATE = 29;
   */
  BO_REBATE = 29,

  /**
   * Best Bid Quantity
   *
   * @generated from enum value: BB_QUANTITY = 30;
   */
  BB_QUANTITY = 30,

  /**
   * Best Bid Fee
   *
   * @generated from enum value: BB_FEE = 31;
   */
  BB_FEE = 31,

  /**
   * Best Bid Rebate
   *
   * @generated from enum value: BB_REBATE = 32;
   */
  BB_REBATE = 32,

  /**
   * BBO Quantity
   *
   * @generated from enum value: BBO_QUANTITY = 33;
   */
  BBO_QUANTITY = 33,

  /**
   * BBO Fee
   *
   * @generated from enum value: BBO_FEE = 34;
   */
  BBO_FEE = 34,

  /**
   * BBO Rebate
   *
   * @generated from enum value: BBO_REBATE = 35;
   */
  BBO_REBATE = 35,

  /**
   * Spread% (Rebate)
   *
   * @generated from enum value: BBO_SPREAD_PCT_REBATE = 36;
   */
  BBO_SPREAD_PCT_REBATE = 36,

  /**
   * Spread vs BBO (Fee)
   *
   * @generated from enum value: BBO_SPREAD_VS_FEE = 37;
   */
  BBO_SPREAD_VS_FEE = 37,

  /**
   * Spread vs BBO (Rebate)
   *
   * @generated from enum value: BBO_SPREAD_VS_REBATE = 38;
   */
  BBO_SPREAD_VS_REBATE = 38,

  /**
   * BBO Agreement
   *
   * @generated from enum value: BBO_AGREEMENT = 39;
   */
  BBO_AGREEMENT = 39,

  /**
   * Instrument ISIN
   *
   * @generated from enum value: INSTRUMENT_ISIN = 44;
   */
  INSTRUMENT_ISIN = 44,

  /**
   * Percentage of par value
   *
   * @generated from enum value: PERCENTAGE_PAR = 45;
   */
  PERCENTAGE_PAR = 45,
}

/**
 * Describes the enum aurora.core.consts.query.SortableField.
 */
export const SortableFieldSchema: GenEnum<SortableField> = /*@__PURE__*/
  enumDesc(file_consts_queryconsts, 0);

/**
 * @generated from enum aurora.core.consts.query.SortOrder
 */
export enum SortOrder {
  /**
   * @generated from enum value: UNSPECIFIED_SORT_ORDER = 0;
   */
  UNSPECIFIED_SORT_ORDER = 0,

  /**
   * @generated from enum value: ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum aurora.core.consts.query.SortOrder.
 */
export const SortOrderSchema: GenEnum<SortOrder> = /*@__PURE__*/
  enumDesc(file_consts_queryconsts, 1);

